import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import {
  Box,
  Divider,
  Grid,
  styled,
  Typography
} from '@mui/material';

import {
  getEmployeeEWFByidEmp
} from '../../../../actions/employee-welfare-fund';

const StyledRoot = styled(Box)(({ leftfund }) => ({
  "& .Topic":{
    fontWeight: 600, 
    fontSize: 20
  },
  "& .disbledEdit":{
    color:"#bdbdbd"
  },
  "& .text": {
    color: leftfund === "true" ? "#bdbdbd" : "initial",
  },
}));

const StyledDivider = styled(Divider)({
  marginTop: 16,
  borderWidth: "0px 0px thin",
  borderColor: "#919eab52",
  borderStyle: "dashed",
  width: "100%",
});

const EmployeeWelfareFund = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: employeeWelfareFund } = useSelector(
    (state) => state.employeeWelfareFund
  );

  const [isJoined, setIsJoined] = useState(false);

  useEffect(() => {
    dispatch(getEmployeeEWFByidEmp());
  },[]);

  useEffect(() => {
    if (employeeWelfareFund) {
      setIsJoined(employeeWelfareFund.isJoinFund === 1 ? true : false);
    }else{
      setIsJoined(false);
    }
  }, [employeeWelfareFund]);

  const formatDate = (date, pattern) => {
    if (!date || !dayjs(date).isValid()) {
      return "-";
    }
    return dayjs(date).format(pattern);
  };

  const hasValue = (value) => value !== null && value !== undefined;

  const monthFormatByLang =
    i18n.resolvedLanguage === "th" ? "DD MMMM BBBB" : "DD MMMM YYYY";

  return (
    <StyledRoot leftfund={`${!isJoined}`}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className="Topic text">{t("AccumulatedRate")}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography align="center" className="text" style={{ fontWeight: "600" }}>
            {`${t("EmployeeSection")}(%)`}
          </Typography>
          <Typography variant="h6" align="center" className="text">
            {employeeWelfareFund && hasValue(employeeWelfareFund.userEWF)
              ? employeeWelfareFund.userEWF 
              : "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography align="center" className="text" style={{ fontWeight: "600" }}>
            {`${t("ContributionCompany")}(%)`}
          </Typography>
          <Typography variant="h6" align="center" className="text">
            {employeeWelfareFund && hasValue(employeeWelfareFund.vendorEWF)
              ? employeeWelfareFund.vendorEWF
              : "-"}
          </Typography>
        </Grid>
      </Grid>

      {employeeWelfareFund && (
        <Box style={{ marginTop: 24 }}>
          <Typography className="Topic">{t("joinFundHistoryEWF")}</Typography>
          {employeeWelfareFund.listHistory.length > 0 ? (
            employeeWelfareFund.listHistory.map((fundDate, index) => (
              <Fragment key={`${fundDate.startDate}_${index + 1}`}>
                <div style={{ display: "flex", marginTop: "16px" }}>
                  <div style={{ minWidth: "80px" }}>
                    <Typography style={{ fontWeight: "600" }}>
                      {`${t("RoundNo")} ${index + 1} :`}
                    </Typography>
                  </div>
                  <div>
                    <Typography>
                      {`${formatDate(fundDate.startDate, monthFormatByLang)}${
                        fundDate.endDate
                          ? ` - ${formatDate(fundDate.endDate, monthFormatByLang)}`
                          : ` - ${t("Current")}`
                      }`}
                    </Typography>
                  </div>
                </div>
              </Fragment>
            ))
          ) : (
            <Typography align="center" style={{ marginTop: "16px" }}>
              {t("noFundHistory")}
            </Typography>
          )}
        </Box>
      )}

    </StyledRoot>
  );
};

export default EmployeeWelfareFund;